import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import { adminGetAllUsers, adminGetUser, adminPatchUser, adminPostUser, adminDeleteUser, resetFocusUser, initNewUser } from "services/user";
import { adminGetAllCenters } from "services/center";
import { getAllNurses, getAllNetworks } from "services/nurse";
import { adminGetAllPartners } from "services/partnerCompany";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/Users/Forms/GeneralForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import RolesForm from "features/Admin/Users/Forms/RolesForm";
import SecondaryButton from "components/Buttons/SecondaryButton";
import * as Yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";

const schemaValidation = Yup.object().shape({
	gender: Yup.string().required("Champ requis"),
	first_name: Yup.string().required("Champ requis"),
	last_name: Yup.string().required("Champ requis"),
	email: Yup.string().email("Email incorrect").required("Champ requis"),
	login: Yup.string().required("Champ requis"),
	password: Yup.string().min(4, "Longueur min : 4 caractères"),
	repassword: Yup.string().min(4, "Longueur min : 4 caractères"),
	comment: Yup.string(),
	nurseMyRdvId: Yup.number().integer().nullable(),
	sampler_code: Yup.string().nullable(),
	role: Yup.string().required("Champ requis"),
	rights: Yup.string().required("Champ requis"),
	expiration_date: Yup.date()
		.nullable()
		.min(moment().format("YYYY-MM-DD"), "La date d'expiration du compte doit être supérieure ou égale à celle d'aujourd'hui"),
});

class UsersAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusUser();
	}

	getAllElements = () => {
		this.props.adminGetAllUsers();
		this.props.getAllNurses();
		this.props.adminGetAllPartners();
		this.props.adminGetAllCenters();
		this.props.getAllNetworks();
	};

	focusOnElement = (elt) => {
		this.props.adminGetUser(elt);
	};

	onAddClick = () => {
		this.props.initNewUser();
	};

	saveFocus = async (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;

			if (values.password === "Ceci est un faux mot de passe" && values.repassword === "Ceci est un faux mot de passe") {
				toast.error("Veuillez modifier le mot de passe");
				setSubmitting(false);
			} else if (values.password !== values.repassword) {
				toast.error("Les mots de passe de correspondent pas");
				setSubmitting(false);
			} else {
				this.props.adminPostUser(values).then((res) => {
					setSubmitting(false);
				});
			}
		} else {
			if (values.password === "Ceci est un faux mot de passe" && values.repassword === "Ceci est un faux mot de passe") {
				delete values.password;
				delete values.repassword;
			}
			this.props.adminPatchUser(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteUser(this.props.users.focus.data);
	};

	render() {
		let user = this.props.users.focus.data;
		let { focus, list } = this.props.users;
		let newUser = user !== null && user.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={
						this.props.users.list && this.props.users.list.data && this.props.users.list.data.length > 0
							? {
									loading: this.props.users.list.loading,
									data: this.props.users.list.data.map((elt) => {
										return { ...elt, role: elt.rights === "INACTIVE" ? "COMPTES INACTIFS" : elt.role };
									}),
							  }
							: this.props.users.list
					}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="UTILISATEURS"
					addButtonText="Nouvel utilisateur"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.last_name.toUpperCase() + " " + e.first_name + " - " + e.login}
					groupField="role"
					focusedEltId={user}
				/>

				<ElementFocus element={focus} list={list} entity="Utilisateurs" icon="users">
					{user !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: user.id,
								gender: user.gender || "",
								first_name: user.first_name || "",
								last_name: user.last_name || "",
								email: user.email || "",
								login: user.login || "",
								password: "Ceci est un faux mot de passe",
								repassword: "Ceci est un faux mot de passe",
								comment: user.comment || "",
								role: user.role || "",
								rights: user.rights || "",
								nurseMyRdvId: user.nurseMyRdvId ? user.nurseMyRdvId : null,
								sampler_code: user.sampler_code || "",
								resetPassword: user.resetPassword ?? false,
								secretary_level: user.secretary_level || null,
								expiration_date: user.expiration_date || null,
								external_sampler: user.external_sampler ?? false,
								external_center: user.external_center || null,
								sound_notification: user.sound_notification || "",
								access_nurse_app: user.access_nurse_app || null,
								nurse_app_center: user.nurse_app_center || null,
								networkMyRdvId: user.networkMyRdvId ? user.networkMyRdvId : null,
								external_network: user.networkMyRdvId ?? false,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								!values.external_network ? (values.networkMyRdvId = null) : (values.nurseMyRdvId = null);
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors, values, touched, setFieldValue }) => {
								return (
									<Form>
										<Grid style={{ margin: 0 }}>
											<Grid.Row columns={1}>
												<Grid.Column>
													<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusUser}>
														Fermer
													</SecondaryButton>
													<MainButton
														text={<Icon name="save" />}
														type="submit"
														style={{ float: "left" }}
														isSubmitting={isSubmitting}
														disabled={
															(Object.entries(errors).length > 0 && errors.constructor === Object) ||
															!(() => {
																if (values.access_nurse_app === "CT1" && (values.nurseMyRdvId === "" || values.nurseMyRdvId === null)) {
																	return false;
																}

																if (values.external_sampler && (values.external_center === "" || values.external_center === null)) {
																	return false;
																}
																if (
																	values.access_nurse_app &&
																	!values.external_sampler &&
																	["CT7"].includes(values.access_nurse_app) &&
																	(values.nurse_app_center === "" || values.nurse_app_center === null)
																) {
																	return false;
																}

																return true;
															})()
														}
													>
														{newUser ? "Créer" : "Enregistrer"}
													</MainButton>

													{!newUser && (
														<RedButton
															text={<Icon name="trash" />}
															type="button"
															onClick={(e) => {
																if (e !== undefined) e.preventDefault();
																this.deleteFocus();
															}}
															style={{ float: "right" }}
														>
															Supprimer
														</RedButton>
													)}
												</Grid.Column>
											</Grid.Row>

											<Grid.Row columns={2}>
												<Grid.Column>
													<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
														<GeneralForm errors={errors} touched={touched} values={values} />
													</AdminDataContainer>
												</Grid.Column>

												<Grid.Column>
													<AdminDataContainer ribbonColor="orange" ribbonLabel="Rôles">
														<RolesForm
															values={values}
															errors={errors}
															touched={touched}
															isAdmin={this.props.user.session.rights === "ADMIN"}
															partnersList={this.props.partners}
															centers={this.props.centers}
															setFieldValue={setFieldValue}
															nurses={this.props.nurses}
														/>
													</AdminDataContainer>
												</Grid.Column>
											</Grid.Row>
										</Grid>
									</Form>
								);
							}}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
};

const mapStateToProps = (state) => {
	return {
		users: state.admin.users,
		nurses: state.nurses,
		user: state.user,
		partners: state.admin.partners,
		centers: state.centers.list,
	};
};

const mapDispatchToProps = {
	adminGetAllCenters,
	adminGetAllUsers,
	adminGetUser,
	adminPatchUser,
	adminDeleteUser,
	resetFocusUser,
	adminPostUser,
	initNewUser,
	getAllNurses,
	getAllNetworks,
	adminGetAllPartners,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersAdmin);
